import React, { useState, useEffect, Fragment } from 'react';
import './MultipleSelection.scss';
import Button from '../../../../partials/Button';
import {SimpleModal} from '../../../../partials/Modal'
import FeedbackBlock from '../../../../partials/FeedbackBlock'
import Scroll from '../../../../partials/Scroll/Scroll';

const MultipleSelection = (props) => {
  console.log(props)
  const { data, onComplete } = props;

  const options = props.options || {};

  const [ order, setOrder ] = useState(data.options || []);
  const [optionSelected, setOptionSelected] = useState([]);
  const [blockSelection, setBlockSelection] = useState(false);
  const [errors, SetErrors] = useState(false);

  const resetStep = () => {
    setOptionSelected([]);
    setBlockSelection(false);
    SetErrors(false);
    randomizeOptions();
  }

  const passValidation = () => {
    
    let err = 0;
    data.options.forEach((option, optionIndex) => {
      if(option.correct) {
        if(optionSelected.indexOf(optionIndex) === -1) {
          err += 1;
        }
      } else {
        if(optionSelected.indexOf(optionIndex) !== -1) {
          err += 1;
        }
      }
    });
    
    if(err > 0) {
      SetErrors(true);
    } else {
      SetErrors(false);
    }
    
  };

  const randomizeOptions = () => {
    let newOrder = [];
    if(options.hasOwnProperty("randomizeOptions")) {
      if(options.randomizeOptions) {
       newOrder = data.options.sort( (a, b) => 0.5 - Math.random() );
      }
    } else {
      newOrder = data.options;
    }
    setOrder(newOrder);
  };
  const handleFeedback = () => {
    if( optionSelected !== null && optionSelected !== undefined ) {

      if(errors) {
        resetStep()
      }
      else{
        onComplete(false)
      }

    }
  }

  useEffect(() => {
    // console.log('new data', data)
    resetStep()
  }, [data])

  return <div className="multiple-selection">

    <div className="options-container">
      <Scroll>
        <div className="options">
        <div className="label">
          <h2>{data.questionText}</h2>
        </div>
        {
         order.map( (option, optionIndex) => (
          <div className="option-icon" key={`o-${optionIndex}`}>
            <div
              key={`option-${optionIndex}`}
              className={`option ${optionSelected.indexOf(optionIndex) !== -1 ? 'selected' : 'not-selected'}`} 
              onClick={ () => { 
                if(!blockSelection) {
                  if(optionSelected.includes(optionIndex)) {
                    setOptionSelected(optionSelected.filter((item) => item !==optionIndex));
                  } else {
                    setOptionSelected([
                      ...optionSelected,
                      optionIndex
                    ]);
                  }
                }
                  }}>
                {option.text} 
            </div><span>
            { blockSelection && optionSelected.indexOf(optionIndex) !== -1 &&
                  <>
                  { !option.correct ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                    <g id="Group_183" data-name="Group 183" transform="translate(-750 -546)">
                      <g id="Ellipse_257" data-name="Ellipse 257" transform="translate(751 547)" fill="#a31621" stroke="#283044" stroke-width="1">
                        <circle cx="13" cy="13" r="13" stroke="none"/>
                        <circle cx="13" cy="13" r="13.5" fill="none"/>
                      </g>
                      <g id="Group_974" data-name="Group 974" transform="translate(-60.161 251.253)">
                        <path id="Union_49" data-name="Union 49" d="M8,10.56,2.56,16,0,13.44,5.44,8,0,2.56,2.56,0,8,5.44,13.44,0,16,2.56,10.56,8,16,13.44,13.44,16Z" transform="translate(816.161 300.747)" fill="#eee5e9"/>
                      </g>
                    </g>
                  </svg>
                  
                  
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                    <g id="Component_5_1" data-name="Component 5 – 1" transform="translate(1 1)">
                      <g id="Path_226" data-name="Path 226" fill="#63c132">
                        <path d="M 13 26.5 C 9.394020080566406 26.5 6.003870010375977 25.09575080871582 3.454060077667236 22.54594039916992 C 0.9042500257492065 19.99612998962402 -0.5 16.60597991943359 -0.5 13 C -0.5 9.394020080566406 0.9042500257492065 6.003870010375977 3.454060077667236 3.454060077667236 C 6.003870010375977 0.9042500257492065 9.394020080566406 -0.5 13 -0.5 C 16.60597991943359 -0.5 19.99612998962402 0.9042500257492065 22.54594039916992 3.454060077667236 C 25.09575080871582 6.003870010375977 26.5 9.394020080566406 26.5 13 C 26.5 15.93484973907471 25.56212997436523 18.6992301940918 23.71242904663086 21.21636009216309 C 22.56595993041992 22.78352928161621 20.99772071838379 24.10087013244629 19.17787933349609 25.02510070800781 C 17.2779598236084 25.989990234375 15.14169025421143 26.5 13 26.5 Z" stroke="none"/>
                        <path d="M 13 0 C 5.82029914855957 0 0 5.82029914855957 0 13 C 0 20.1796989440918 5.82029914855957 26 13 26 C 17.30781936645508 26 21.12625885009766 23.90468978881836 23.30952072143555 20.92026901245117 C 25.06875038146973 18.52626037597656 26 15.87187957763672 26 13 C 26 5.82029914855957 20.1796989440918 0 13 0 M 13 -1 C 16.73952865600586 -1 20.25523948669434 0.4562492370605469 22.89949035644531 3.100509643554688 C 25.54375076293945 5.744760513305664 27 9.260469436645508 27 13 C 27 16.04364967346191 26.02946090698242 18.90764045715332 24.1153392791748 21.51243019104004 C 22.92333984375 23.14184951782227 21.2938404083252 24.51127052307129 19.4042797088623 25.47089958190918 C 17.4345588684082 26.47125053405762 15.21998977661133 27 13 27 C 9.260469436645508 27 5.744760513305664 25.54375076293945 3.100509643554688 22.89949035644531 C 0.4562492370605469 20.25523948669434 -1 16.73952865600586 -1 13 C -1 9.260469436645508 0.4562492370605469 5.744760513305664 3.100509643554688 3.100509643554688 C 5.744760513305664 0.4562492370605469 9.260469436645508 -1 13 -1 Z" stroke="none" fill="#283044"/>
                      </g>
                      <path id="Icon_awesome-check" data-name="Icon awesome-check" d="M5.774,17.005.249,11.48a.85.85,0,0,1,0-1.2l1.2-1.2a.85.85,0,0,1,1.2,0L6.375,12.8l7.972-7.972a.85.85,0,0,1,1.2,0l1.2,1.2a.85.85,0,0,1,0,1.2L6.976,17.005A.85.85,0,0,1,5.774,17.005Z" transform="translate(4.5 1.923)" fill="#283044"/>
                    </g>
                  </svg>
                  }
                  </>
                }</span>
            </div>
          ))
        }
      </div>
      </Scroll>
      <div className="notes">
        {/* {
          order.map( (option, optionIndex) => (
            <Fragment key={`note-${optionIndex}`}>
              <div className={`notes ${optionSelected===optionIndex ? 'selected' : 'not-selected'}`} dangerouslySetInnerHTML={{ __html:option.notes }}></div>
              { blockSelection && optionSelected===optionIndex &&
                <div className="feedback">
                  <hr />
                  <div dangerouslySetInnerHTML={{ __html: errors ? data.feedback.missedCorrect : data.feedback.allCorrect }}></div>
                </div>
              }
            </Fragment>
          ))
        } */}
        {/* { blockSelection && <div className='feedback'>
          <hr />
          <div dangerouslySetInnerHTML={{ __html: errors ? data.feedback.missedCorrect : data.feedback.allCorrect }}></div>
        </div>} */}
      </div>

      { optionSelected.length > 0 && blockSelection &&
        <SimpleModal size="small" scroll={false}  show={true} className='simple-modal'>
          <FeedbackBlock variant="fill" status={!errors ? 'success':'failed'} caption={!errors ? 'Correct':'Incorrect'}>
            <Scroll>
              <div className='feedback-text' dangerouslySetInnerHTML={{ __html: errors ? data.feedback.missedCorrect : data.feedback.allCorrect }}></div> 
            </Scroll>
            { !errors &&
                <Button text="Next" onClick={ handleFeedback } /> 
            }
            { errors &&
                <Button text="Retry" onClick={ handleFeedback } /> 
            }            
          </FeedbackBlock>

        </SimpleModal>
      } 



      { optionSelected.length > 0 &&
        <div className="action">
          {/* { errors && blockSelection &&
            <Button text="Retry" className="red" onClick={ resetStep }/>
          } */}
          { !blockSelection &&
            <Button 
              text="Submit"
              onClick={ () => { 
                setBlockSelection(true);
                passValidation();
              }}/>
          }
          {/* { !errors && blockSelection ? 
            <Button text="Next" onClick={ () => { onComplete(errors) } }/>
            :
            <>
              { data.canContinueWithErrors && blockSelection &&  <Button text="Next" onClick={ () => { onComplete(errors) } }/>}
            </>
          } */}
        </div>
      } 
    </div>
  </div>
}

export default MultipleSelection;